import { all } from 'redux-saga/effects';
import { clearEventSaga, createEventSaga, patchEventSaga, updateEventSaga } from './events/CreateEventSaga';
import { getEventSaga } from './events/EventNameValidationSaga';
import { getAllEventSaga } from './events/FetchAllEventSaga';
import { importEventSagaHandler } from './events/ImportEventSaga';
import { getSchemaSaga } from './events/SchemaNameValidationSaga';
import { getCreateNewExceptionSaga } from './exceptions/CreateNewExceptionSaga';
import { getAllExceptionListSaga } from './exceptions/FetchAllExceptionListSaga';
import { getExceptionDetailSaga } from './exceptions/GetExceptionSaga';
import { deleteScheduledMaintenanceSaga } from './schedule-maintenance/DeleteScheduledMaintenanceSaga';
import { getBannerDataSaga } from './schedule-maintenance/GetBannerDataSaga';
import { getScheduledMaintenanceSaga } from './schedule-maintenance/GetScheduledMaintenanceSaga';
import { getMaintenanceStatusSaga } from './schedule-maintenance/PostMaintenanceStatusSaga';
import { saveMaintenanceSaga } from './schedule-maintenance/SaveMaintenanceSaga';
import { getSmLogHistorySaga } from './schedule-maintenance/SmLogHistorySaga';
import { clearServiceSaga, createServiceSaga } from './services/CreateServiceSaga';
import { getAllServiceSaga } from './services/FetchAllServiceSaga';
import { getExceptionSaga } from './services/FetchExceptionSaga';
import { getServiceEventSaga } from './services/FetchServiceEventSaga';
import { getServiceEventSchemaSaga } from './services/FetchServiceEventSchema';
import { getServicesSaga } from './services/GetServicesSaga'; // Schedule Maintenance
import { ImportServiceSummarySagaHandler } from './services/ImportServiceSummarySaga';
import { addServiceEventMappingsSaga, clearServiceEventsMappingSaga, deleteServiceEventsMappingSaga, updateServiceEventsMappingSaga } from './services/ServiceEventMappingSaga';
import { getServiceExceptionListSaga } from './services/ServiceExceptionListSaga';
import { getServiceDetailsSaga } from './services/ServiceNameValidationSaga';
import {
  addServiceOperationDataSaga,
  clearServiceOperationSaga,
  deleteServiceOperationSaga,
  updateServiceOperationSaga
} from './services/ServiceOperationSaga';
import { updateServiceSaga } from './services/UpdateServiceSaga';
import { createNewSourceRegistrySaga } from './sources/CreateSourceRegistrySaga';
import { getAllFSMRegistriesSaga } from './sources/FetchAllFSMRegistrySaga';
import { getAllJourneysSaga } from './sources/FetchAllJourneyListSaga';
import { getAllSourceRegistriesSaga } from './sources/FetchAllSourceRegistriesSaga';

/**
 * Root Saga function to combine all sagas
 */
export function* rootSaga() {
  yield all([
    ...getEventSaga,
    ...createEventSaga,
    ...updateEventSaga,
    ...patchEventSaga,
    ...clearEventSaga,
    ...createServiceSaga,
    ...clearServiceSaga,
    ...addServiceOperationDataSaga,
    ...clearServiceOperationSaga,
    ...deleteServiceOperationSaga,
    ...getServiceDetailsSaga,
    ...updateServiceOperationSaga,
    ...getSchemaSaga,
    ...getServiceEventSaga,
    ...getServiceEventSchemaSaga,
    ...addServiceEventMappingsSaga,
    ...clearServiceEventsMappingSaga,
    ...deleteServiceEventsMappingSaga,
    ...updateServiceEventsMappingSaga,
    ...getAllServiceSaga,
    ...getAllEventSaga,
    ...getExceptionSaga,
    ...getServiceExceptionListSaga,
    ...updateServiceSaga,
    ...getAllExceptionListSaga,
    ...getCreateNewExceptionSaga,
    ...createNewSourceRegistrySaga,
    ...getAllSourceRegistriesSaga,
    ...getAllJourneysSaga,
    ...importEventSagaHandler,
    ...getBannerDataSaga,
    ...getSmLogHistorySaga,
    ...getScheduledMaintenanceSaga,
    ...getMaintenanceStatusSaga,
    ...saveMaintenanceSaga,
    ...deleteScheduledMaintenanceSaga,
    ...getServicesSaga,
    ...getAllFSMRegistriesSaga,
    ...ImportServiceSummarySagaHandler,
    ...getExceptionDetailSaga
  ]);
}
